import { render, staticRenderFns } from "./productComment.vue?vue&type=template&id=5e95e2ee&scoped=true"
import script from "./productComment.vue?vue&type=script&lang=js"
export * from "./productComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e95e2ee",
  null
  
)

export default component.exports